import { createDirectionalHopFrames } from "../../core/directional-hop-keyframes.js";

export const meta = Object.freeze({
  id: "hop-left",
  label: "Zweimal nach links",
  duration: 2350,
  description: "Zwei seitliche Hüpfer nach links und ein elastischer Rücksprung zur Mitte.",
  tags: ["body", "directional", "left", "one-shot", "loopable"],
});

export async function run({ elements, animate }) {
  const frames = createDirectionalHopFrames(-1);
  const body = animate(elements.actor, frames.body, { duration: meta.duration, easing: "linear" });
  const shadow = animate(elements.shadow, frames.shadow, { duration: meta.duration, easing: "linear" });
  await Promise.allSettled([body.finished, shadow.finished]);
}
